import TrophyBold from "../../../assets/icons/TrophyBold";

const PlaceholderImage = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props} className="flex aspect-square items-center justify-center rounded-xl bg-failingImageBg">
      <TrophyBold className="w-3/4 text-failingImageColor" />
    </div>
  );
};

export default PlaceholderImage;
